import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const userDetails = useSelector((state) => state.login.userDetails);
  if (!userDetails) {
    return <Navigate to="/configure/login" replace />;
  }
  return children;
};

export default ProtectedRoute;
